/** @jsxImportSource @emotion/react */
import { ListSubheader } from '@mui/material';
import React from 'react';
import { UseStyles } from 'types/styles';

export const SelectGroupSeparator: React.FC = () => {
  const classes = useStyles();

  return (
    <ListSubheader css={classes.SelectGroupSeparator}>
      <hr />
    </ListSubheader>
  );
};

const useStyles = (): UseStyles => ({
  SelectGroupSeparator: {
    '& hr': {
      margin: '16px 0',
      border: 'none',
      borderBottom: '1px solid #ECECEF',
    },
  },
});
